import React from "react";
import "./TrueFalseTableElement.css";
import ReactTooltip from "react-tooltip";

function TrueFalseTableElement(props) {
  const stringMessages = props.messages.reduce((acc, error) => {
    return acc + "<br />" + error;
  }, "");

  return (
    <div className="true-false__common-container">
      <span
        className={!props.condition ? "alert" : ""}
      >{`${props.condition}`}</span>
      {!props.condition && (
        <img
          src="images/info-icon.png"
          alt="more information"
          data-tip={stringMessages}
        />
      )}
      <ReactTooltip multiline={true} />
    </div>
  );
}

export default TrueFalseTableElement;
